import { render, staticRenderFns } from "./inspectCountscore.vue?vue&type=template&id=3e638461&scoped=true&"
import script from "./inspectCountscore.vue?vue&type=script&lang=js&"
export * from "./inspectCountscore.vue?vue&type=script&lang=js&"
import style0 from "./inspectCountscore.vue?vue&type=style&index=0&id=3e638461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e638461",
  null
  
)

export default component.exports